module.exports = __webpack_public_path__ + "img/house0b.f5955f7a.jpg";